/* Native collection controls. No carousel library, polling or page-load image prefetch. */
(function () {
  'use strict';
  if (window.__clyroCollectionUI) return;
  window.__clyroCollectionUI = true;
  function secondImage(card) {
    var image = card.querySelector('[data-collection-second-image]');
    if (!image) return Promise.resolve(false);
    if (card.hasAttribute('data-second-ready')) return Promise.resolve(true);
    if (image._clyroLoading) return image._clyroLoading;
    image._clyroLoading = new Promise(function (resolve) {
      image.onload = function () { card.setAttribute('data-second-ready', ''); resolve(true); };
      image.onerror = function () { image._clyroLoading = null; resolve(false); };
      image.srcset = image.dataset.srcset;
      image.src = image.dataset.src;
    });
    return image._clyroLoading;
  }
  function hover(event) {
    var link = event.target.closest && event.target.closest('.collection-product-link');
    var card = link && link.closest('[data-hover-image="true"]');
    if (card && window.matchMedia('(hover: hover) and (pointer: fine)').matches) secondImage(card);
  }
  document.addEventListener('pointerover', hover, { passive: true });
  document.addEventListener('focusin', hover);
  document.addEventListener('click', function (event) {
    var target = event.target.closest && event.target.closest('[data-collection-image], [data-story-direction]');
    if (!target) return;
    if (target.hasAttribute('data-story-direction')) {
      var track = target.closest('[data-story-row]').querySelector('[data-story-track]');
      track.scrollBy({ left: Number(target.dataset.storyDirection) * track.clientWidth * 0.8,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      return;
    }
    var card = target.closest('.collection-product-card');
    if (!card) return;
    var useSecond = target.dataset.collectionImage === 'second';
    card._imageIntent = (card._imageIntent || 0) + 1;
    var intent = card._imageIntent;
    function apply(loaded) {
      if (intent !== card._imageIntent) return;
      card.toggleAttribute('data-second-visible', useSecond && loaded);
      card.querySelectorAll('[data-collection-image]').forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.collectionImage === (useSecond && loaded ? 'second' : 'first')));
      });
    }
    if (useSecond) secondImage(card).then(apply); else apply(true);
  });
})();
